/* eslint-disable react/prop-types */
import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Dropdown, Button, Segment, Grid, Divider, Form, Popup, Icon, Accordion, Dimmer, Loader } from "semantic-ui-react";
import Chart from "react-apexcharts";
import ApexCharts from "apexcharts";
import Constants from "./utilities/Constants";
import Strings from "./utilities/Strings";
import Utils from "./utilities/Utils";

var cursorCount = 0;

const UtilsInstance = new Utils();

let selectedAddress = 0;

export class Oscilloscope extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isAutomaticCheckboxChecked: true,
      isDimmerActive: false,
      isDetailedModeCheckboxChecked: true,

      oscilloscopeData: [],

      devices: [],
      wave: [],
      selectedDropdownAddress: -1,

      timeCursorValues: [],
      voltageCursorValues: [],
      cursorTimeUnit: Strings.MICROSSECOND,

      playButtonColor: "grey",
      pauseButtonColor: "grey",

      amplitudeActive: false,
      timeActive: false,

      series: [{ data: [] }],
      options: {
        tooltip: {
          enabled: true,
          intersect: false,
          shared: false,
          onDatasetHover: {
            highlightDataSeries: true
          },
          x: {
            show: true,
            formatter: function (val) {
              return "Tempo: " + val.toFixed(2) + Strings.MICROSSECOND;
            },
          },
        },
        chart: {
          id: Constants.OSCILLOSCOPE_CHART_ID,
          type: "line",
          locales: [{
            "name": "pt-br",
            "options": {
              "months": [
                "Janeiro",
                "Fevereiro",
                "Março",
                "Abril",
                "Maio",
                "Junho",
                "Julho",
                "Agosto",
                "Setembro",
                "Outubro",
                "Novembro",
                "Dezembro"
              ],
              "shortMonths": [
                "Jan",
                "Fev",
                "Mar",
                "Abr",
                "Mai",
                "Jun",
                "Jul",
                "Ago",
                "Set",
                "Out",
                "Nov",
                "Dez"
              ],
              "days": [
                "Domingo",
                "Segunda",
                "Terça",
                "Quarta",
                "Quinta",
                "Sexta",
                "Sábado"
              ],
              "shortDays": ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sab"],
              "toolbar": {
                "exportToSVG": "Baixar SVG",
                "exportToPNG": "Baixar PNG",
                "exportToCSV": "Baixar CSV",
                "menu": "Baixar",
                "selection": "Selecionar",
                "selectionZoom": "Selecionar Zoom",
                "zoomIn": "Aumentar",
                "zoomOut": "Diminuir",
                "pan": "Navegação",
                "reset": "Reiniciar Zoom"
              }
            }
          }],
          defaultLocale: "pt-br",
          zoom: {
            type: "x",
            enabled: false,
            autoScaleYaxis: true
          },
          toolbar: {
            show: false
          },
          animations: {
            enabled: false,
            easing: "linear",
            speed: 500,
            animateGradually: {
              enabled: true,
              delay: 150
            },
            dynamicAnimation: {
              enabled: true,
              speed: 350
            }
          },
          events: {
            click: (event, chartContext, config) => {
              if (this.state.amplitudeActive) {
                this.addYAxisAnnotation(config.dataPointIndex, config.seriesIndex);
              }
              else if (this.state.timeActive) {
                this.addXAxisAnnotation(config.dataPointIndex);
              }
            },
            scrolled: () => {
              if (this.state.amplitudeActive || this.state.timeActive) {
                this.setState({
                  amplitudeActive: false,
                  timeActive: false
                });

                this.clearAllAnnotations();
              }
            },
            selection: () => {
              if (this.state.amplitudeActive || this.state.timeActive) {
                this.setState({
                  amplitudeActive: false,
                  timeActive: false
                });

                this.clearAllAnnotations();
              }
            },
            zoomed: () => {
              if (this.state.amplitudeActive || this.state.timeActive) {
                this.setState({
                  amplitudeActive: false,
                  timeActive: false
                });

                this.clearAllAnnotations();
              }
            }
          }
        },
        colors: [Constants.RED_HEX],
        markers: {
          size: 0
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          curve: "straight",
          width: 2
        },
        xaxis: {
          type: "numeric",
          title: {
            text: Strings.TIME_US
          },
          crosshairs: {
            show: "true"
          },
          tooltip: {
            enabled: false
          },
          labels: {
            show: true,
            formatter: function (value) {
              if (value !== undefined && value < 10) {
                return value.toFixed(2);
              }
              else if (value !== undefined && value >= 10) {
                return value.toFixed(0);
              }
              else {
                return value;
              }
            }
          }
        },
        yaxis: {
          min: -1000,
          max: 1000,
          labels: {
            formatter: function (val) {
              return val.toFixed(2) + " " + Strings.MILLIVOLT;
            },
          },
          title: {
            text: Strings.VOLTAGE_MV
          },
        },
        annotations: {
          position: "front",
          xaxis: []
        }
      },

      errorMessages: []
    };
  }

  // Since the devices in H1 protocol are not numbered with simple integers
  // We need to convert, 1A and 1B for exemple, into sortable integers
  // Every device that has A in its address has its number as the sortable integer
  // Every device that has B in its addres, has its number + 32 as the sortable integer
  // Every device that has master in its name has its number be 0
  addOrderValueToDevices = () => {
    let devicesCopy = this.state.devices;
    
    for (let i = 0; i < devicesCopy.length; i++) {
      let deviceName = devicesCopy[i].address;
      devicesCopy[i].order = parseInt(deviceName);
    }

    this.setState({
      devices: devicesCopy.sort(UtilsInstance.sortBy(
        "order",
        false,
        parseInt))
    }, () => {
      // After adding the order, start the auto visualization
      this.startAutoVisualization();
    });
  }

  retrieveData = async () => {
    this.setDimmerActiveState(true);
    // Get livelist data
    fetch(Constants.REQUEST_IP_ADDRESS + "liveList/" + parseInt(localStorage.getItem(Constants.ACTIVE_CHANNEL)), { mode: "cors" })
      .then(res => res.json())
      .then(data => this.setState({
        devices: data,
      }, () => {
        this.addOrderValueToDevices();
      }));
  }

  // formatWaveTimes = (wave) => {
  //   if (wave[wave.length - 1][0] < 1000) {
  //     // Set the time values to nanosseconds 
  //     // (it already is by default, so do nothing here)
  //   }
  //   else if (wave[wave.length - 1][0] >= 1000
  //     && wave[wave.length - 1][0] < 1000000) {
  //     // Set the time values to microsseconds
  //     for (let i = 0; i < wave.length; i++) {
  //       wave[i][0] = wave[i][0] / (10 ** 3);
  //     }
  //   }
  //   else if (wave[wave.length - 1][0] >= 1000000) {
  //     // Set the time values to millisseconds
  //     for (let i = 0; i < wave.length; i++) {
  //       wave[i][0] = wave[i][0] / (10 ** 6);
  //     }
  //   }
  //   return wave;
  // }

  formatWaveTimes = (wave) => {
    // Set the time values to microsseconds
    for (let i = 0; i < wave.length; i++) {
      wave[i][0] = wave[i][0] / (10 ** 3);
    }
    return wave;
  }

  convertWaveValuesTomV = (wave) => {
    for (let i = 0; i < wave.length; i++) {
      wave[i][1] = wave[i][1] * 1000;
    }

    return wave;
  }

  getFormatedOptions = (wave, deviceAddress, isMaster) => {
    let options = {};

    // Set the time values to microsseconds
    options = {
      ...this.state.options,
      tooltip: {
        enabled: true,
        intersect: false,
        shared: false,
        onDatasetHover: {
          highlightDataSeries: true
        },
        x: {
          show: true,
          formatter: function (val) {
            return "Tempo: " + val.toFixed(2).replace(".", ",") + Strings.MICROSSECOND;
          },
        },
      },
      xaxis: {
        type: "numeric",
        title: {
          text: Strings.TIME_US
        },
        crosshairs: {
          show: "true"
        }
      },
      title: {
        text: deviceAddress + UtilsInstance.getMasterSuffix(isMaster),
        align: "center"
      }
    };

    this.setState({ cursorTimeUnit: Strings.MICROSSECOND });
    return options;
  }

  // --------------- Dropdown Methods -------------------------------
  buildDevicesDropdownOptions = (devices) => {
    let dropdownMap = devices.map(device => (
      {
        key: device.address,
        text: Strings.ADDRESS_DP + device.address + UtilsInstance.getMasterSuffix(device.isMaster),
        value: device.address

      }
    ));
    return dropdownMap;
  }

  onDevicesDropdownChange = (e, { value }) => {
    this.setState({
      selectedDropdownAddress: value,
      playButtonColor: "grey",
      pauseButtonColor: "red"
    }, () => {
      clearInterval(this.state.intervalID);
      this.getDeviceWaveData(this.state.selectedDropdownAddress);
      this.clearAllAnnotations();
      this.setDisabledButtonsState(false, false, false, false);
    });
  }

  // ---------------------- Control Buttons ----------------------
  handlePlayButtonClick = () => {
    // Only try to start if it is not already on
    if (this.state.playButtonColor !== "green") {

      let intervalID = -1;

      // First clear all annotations
      this.clearAllAnnotations();

      this.getDeviceWaveData(this.state.selectedDropdownAddress);
      // Then set for the data to be refreshed every 5 seconds
      intervalID = setInterval(
        () => {
          this.getDeviceWaveData(this.state.selectedDropdownAddress);
        }, Constants.PLAY_REFRESH_INTERVAL_MS
      );

      // And change the color of the buttons
      this.setDisabledButtonsState(false, false, true, true);

      this.setState({
        intervalID: intervalID,
        playButtonColor: "green",
        pauseButtonColor: "grey"
      });
    }
  }

  handlePauseButtonClick = () => {
    // Stop the data refresh
    clearInterval(this.state.intervalID);

    this.setDisabledButtonsState(false, false, false, false);

    this.setState({
      playButtonColor: "grey",
      pauseButtonColor: "red"
    });
  }

  // ---------------------- Cursor Buttons  ----------------------
  handleAmplitudeButtonClick = () => {
    this.setState({
      amplitudeActive: !this.state.amplitudeActive,
      timeActive: false
    });

    this.clearAllAnnotations();
  }

  handleTimeButtonClick = () => {
    this.setState({
      timeActive: !this.state.timeActive,
      amplitudeActive: false
    });

    this.clearAllAnnotations();
  }

  // ---------------------- Button States ----------------------
  setDisabledButtonsState = (playState, pauseState, amplitudeState, timeState) => {
    document.getElementById("play-btn").disabled = playState;
    document.getElementById("pause-btn").disabled = pauseState;
    document.getElementById("amplitude-btn").disabled = amplitudeState;
    document.getElementById("time-interval-btn").disabled = timeState;
  }

  // --------------- Cursors Methods -------------------------------
  clearAllAnnotations = () => {
    // Ask ApexCharts to clear the cursors from screen
    ApexCharts.exec(Constants.OSCILLOSCOPE_CHART_ID, "clearAnnotations");

    // Reset the cursors values arrays
    this.setState({
      timeCursorValues: [],
      voltageCursorValues: []
    });

    // Set the cursors calculation texts back to default
    document.getElementById("time-interval").innerText = Strings.TIME_INTERVAL_PLACEHOLDER + this.state.cursorTimeUnit;
    document.getElementById("wave-amplitude").innerText = Strings.AMPLITUDE_PLACEHOLDER;

    // Finally reset the number of active cursors back to 0
    cursorCount = 0;
  }

  addXAxisAnnotation = (dataPointIndex) => {
    // Only let the user set time cursors if the button is enabled
    if (!document.getElementById("time-interval-btn").disabled) {
      let timeCursorValuesCopy = this.state.timeCursorValues;

      // If the user has clicked on the first point, draw the cursor there
      if (dataPointIndex !== -1 && cursorCount === 0) {
        timeCursorValuesCopy.push(this.state.series[0].data[dataPointIndex][0]);

        this.setState({ timeCursorValues: timeCursorValuesCopy }, () => {

          ApexCharts.exec(Constants.OSCILLOSCOPE_CHART_ID, "addXaxisAnnotation", {
            x: this.state.timeCursorValues[0],
            strokeDashArray: 0,
            borderColor: Constants.BLUE_HEX
          });

          cursorCount++;

        });
      }
      // If it is the second point draw a range cursor
      else if (dataPointIndex !== -1 && cursorCount === 1) {
        ApexCharts.exec(Constants.OSCILLOSCOPE_CHART_ID, "clearAnnotations");

        timeCursorValuesCopy.push(this.state.series[0].data[dataPointIndex][0]);

        this.setState({ timeCursorValues: timeCursorValuesCopy }, () => {

          ApexCharts.exec(Constants.OSCILLOSCOPE_CHART_ID, "addXaxisAnnotation", {
            x: this.state.timeCursorValues[0],
            x2: this.state.timeCursorValues[1],
            strokeDashArray: 0,
            fillColor: Constants.BLUE_HEX,
            opacity: 0.4,
            borderColor: Constants.BLUE_HEX
          });

          let timeInterval = Math.abs(this.state.timeCursorValues[0] - this.state.timeCursorValues[1]);

          document.getElementById("time-interval").innerText = timeInterval.toFixed(2).replace(".", ",") + " " + this.state.cursorTimeUnit;

          cursorCount++;
        });
      }
      // If the user clicks on a dataPoint for a third time, clear the cursors
      else if (dataPointIndex !== -1 && cursorCount === 2) {
        this.clearAllAnnotations();
      }
    }
  }

  addYAxisAnnotation = (dataPointIndex, seriesIndex) => {
    // Only let the user set amplitude cursors if the button is enabled
    if (!document.getElementById("amplitude-btn").disabled) {
      let voltageCursorValuesCopy = this.state.voltageCursorValues;

      // If the user has clicked on the first point, draw the cursor there
      if (dataPointIndex !== -1 && cursorCount === 0) {
        voltageCursorValuesCopy.push(this.state.series[seriesIndex].data[dataPointIndex][1]);

        this.setState({ voltageCursorValues: voltageCursorValuesCopy }, () => {

          ApexCharts.exec(Constants.OSCILLOSCOPE_CHART_ID, "addYaxisAnnotation", {
            y: this.state.voltageCursorValues[0],
            yAxisIndex: 0,
            strokeDashArray: 0,
            borderColor: Constants.BLUE_HEX
          });
        });

        cursorCount++;

      }
      // If it is the second point draw a range cursor
      else if (dataPointIndex !== -1 && cursorCount === 1) {
        ApexCharts.exec(Constants.OSCILLOSCOPE_CHART_ID, "clearAnnotations");

        voltageCursorValuesCopy.push(this.state.series[seriesIndex].data[dataPointIndex][1]);

        this.setState({ voltageCursorValues: voltageCursorValuesCopy }, () => {

          ApexCharts.exec(Constants.OSCILLOSCOPE_CHART_ID, "addYaxisAnnotation", {
            y: this.state.voltageCursorValues[0],
            y2: this.state.voltageCursorValues[1],
            strokeDashArray: 0,
            fillColor: Constants.BLUE_HEX,
            opacity: 0.4,
            borderColor: Constants.BLUE_HEX
          });

          let amplitude = Math.abs(this.state.voltageCursorValues[0] - this.state.voltageCursorValues[1]);
          document.getElementById("wave-amplitude").innerText = amplitude.toFixed(2).replace(".", ",") + " " + Strings.MILLIVOLT;

          cursorCount++;
        });
      }
      // If the user clicks on a dataPoint for a third time, clear the cursors
      else if (cursorCount === 2) {
        this.clearAllAnnotations();
      }
    }
  }

  setDimmerActiveState = (state) => {
    this.setState({ isDimmerActive: state });
  }

  /// ---------------- Error Messages -----------------------------
  retrieveWarnings = async () => {
    fetch(Constants.REQUEST_IP_ADDRESS + "warnings/" + parseInt(localStorage.getItem(Constants.ACTIVE_CHANNEL)), { mode: "cors" })
      .then(res => res.json())
      .then(data => {
        this.handleWarningMessages(data);
      });
  }

  handleWarningMessages = (errors) => {
    let errorMessages = [];

    if (errors.invertedPolarity || errors.mongoOFF || errors.picoNotFound || errors.scanFail) {
      // If at least one of the errors above ocurred, unhide the error message's container
      if (document.getElementById("message-list") !== undefined
        && document.getElementById("message-list") !== null) {
        document.getElementById("message-list").style.display = "block";
      }

      if (errors.invertedPolarity) {
        errorMessages.push(Strings.INVERTED_POLARITY);
      }

      if (errors.InitPicoNotFound) {
        errorMessages.push(Strings.INIT_PICO_NOT_FOUND);
      }

      if (errors.firstScanFail) {
        errorMessages.push(Strings.NO_ACTIVE_NETWORK);
      }

      if (errors.mongoOFF) {
        errorMessages.push(Strings.MONGO_OFF);
      }

      if (errors.picoNotFound) {
        errorMessages.push(Strings.PICO_NOT_FOUND);
      }

      if (errors.scanFail) {
        errorMessages.push(Strings.SCAN_FAIL_FOUND);
      }

      this.setState({ errorMessages: errorMessages });
    }
    else {

      if (document.getElementById("message-list") !== undefined
        && document.getElementById("message-list") !== null) {
        document.getElementById("message-list").style.display = "none";

      }

      this.setState({ errorMessages: [] });
    }
  }
  
  /// ---------------- Visualization Type -----------------------------
  handleVisualizationTypeCheckboxChange = (e, { value }) => {
    this.setState({ isAutomaticCheckboxChecked: (value === Constants.AUTOMATIC_CHECKBOX_VAL) }, () => {

      clearInterval(this.state.intervalID);

      if (this.state.isAutomaticCheckboxChecked) {
        this.setState({
          playButtonColor: "grey",
          pauseButtonColor: "red"
        }, () => {
          this.setDisabledButtonsState(true, true, true, true);
          this.startAutoVisualization();
          document.getElementById("devices-dropdown").style.display = "none";
        });
      }
      else {
        document.getElementById("devices-dropdown").style.display = "block";
        clearInterval(this.state.autoVisualizationIntervalID);
        this.setDimmerActiveState(false);
        selectedAddress = 0;
        this.setState({
          series: [{ data: [] }],
          options: {
            ...this.state.options,
            title: {
              text: "",
              align: "center"
            }
          }
        });
      }
    });
  }

  startAutoVisualization = () => {
    this.clearAllAnnotations();
    // Every 2 seconds start cycling through all the devices
    let autoVisualizationIntervalID = setInterval(() => {

      this.setDimmerActiveState(false);

      if (this.state.devices.length > 0) {
        this.getDeviceWaveData(this.state.devices[selectedAddress].address);
      }

      if (selectedAddress === (this.state.devices.length - 1)) {
        selectedAddress = 0;
      }
      else {
        selectedAddress++;
      }

    }, Constants.AUTO_VISUALIZATION_REFRESH_MS);

    // Save the interval ID as a state so it is possible to cancel it later
    this.setState({ autoVisualizationIntervalID: autoVisualizationIntervalID });
  }

  /// ---------------- Errors Accordion -----------------------------
  handleAccordionClick = (e, titleProps) => {
    const { index } = titleProps;
    const { accordionIndex } = this.state;
    const newIndex = accordionIndex === index ? -1 : index;

    this.setState({ accordionIndex: newIndex });
  };

  // ---------------- Get the wave data of the choosen device ----------------
  getDeviceWaveData = (deviceAddress) => {
    let routeName = (this.state.isDetailedModeCheckboxChecked) ? "oscilloscopeWave/" : "oscilloscopeWaveComplete/";

    fetch(Constants.REQUEST_IP_ADDRESS + routeName + parseInt(localStorage.getItem(Constants.ACTIVE_CHANNEL)) + "/" + deviceAddress, { mode: "cors" })
      .then(res => res.json())
      .then(data => this.setState({ oscilloscopeData: data }, () => {
        if (this.state.oscilloscopeData[0] !== undefined) {
          let address = this.state.devices.find(device => device.address === deviceAddress);
          this.setState({
            options: this.getFormatedOptions(this.state.oscilloscopeData[0].wave, deviceAddress, address.isMaster),
            series: [{
              name: Strings.WAVE_H1,
              data: this.formatWaveTimes(this.state.oscilloscopeData[0].wave)
            }]
          });
        }
        // If data for this deviceAddress doesn't exist, set the data as an empty array
        else {
          this.setState({ series: [{ name: Strings.WAVE_H1, data: [] }] });
        }
      }));
  }

  // ---------------- Change Oscilloscope mode between detailed and complete ----------------
  handleModeCheckboxChange = (e, { value }) => {
    this.setState({
      isDetailedModeCheckboxChecked: (value === Constants.DETAILED_MODE_CHECKBOX_VAL)
    });
  }

  // ----------------- Lifecycle Methods ----------------
  componentDidMount() {
    sessionStorage.removeItem("auth");
    selectedAddress = 0;
    this.retrieveData();
    this.retrieveWarnings();
    this.setState({ warningsIntervalID: setInterval(this.retrieveWarnings, 5000) });
    this.setDisabledButtonsState(true, true, true, true);
  }

  componentWillUnmount() {
    clearInterval(this.state.warningsIntervalID);
    clearInterval(this.state.autoVisualizationIntervalID);
    clearInterval(this.state.intervalID);
  }

  render() {
    let dropdownOptions = this.buildDevicesDropdownOptions(this.state.devices);

    return (
      <div style={screenStyle}>

        <Grid columns={2} doubling>
          <Grid.Row>

            <Grid.Column width={4}>
              
              <Segment>
                <Divider horizontal style={dividerStyle}>
                  {Strings.MODE}
                  <Popup position='bottom center' hoverable wide
                    trigger={<Icon name="info circle" color="teal" />}>
                    <Popup.Content>
                      <p>{Strings.MODE_POPUP_TEXT_1}</p>
                      <p>{Strings.MODE_POPUP_TEXT_2}</p>
                    </Popup.Content>
                  </Popup >
                </Divider>
                <Form style={formStyle}>
                  <Form.Group widths="equal">
                    <Form.Checkbox
                      radio
                      label={Strings.DETAILED}
                      checked={this.state.isDetailedModeCheckboxChecked}
                      value={Constants.DETAILED_MODE_CHECKBOX_VAL}
                      onChange={this.handleModeCheckboxChange} />

                    <Form.Checkbox
                      radio
                      label={Strings.COMPLETE}
                      checked={!this.state.isDetailedModeCheckboxChecked}
                      value={Constants.COMPLETE_MODE_CHECKBOX_VAL}
                      onChange={this.handleModeCheckboxChange} />
                  </Form.Group>
                </Form>
              </Segment>

              <Segment>
                <Divider horizontal style={dividerStyle}>{Strings.VISUALIZATION}</Divider>
                <Form style={formStyle}>
                  <Form.Group widths="equal">
                    <Form.Checkbox
                      radio
                      label={Strings.AUTOMATIC}
                      checked={this.state.isAutomaticCheckboxChecked}
                      value={Constants.AUTOMATIC_CHECKBOX_VAL}
                      onChange={this.handleVisualizationTypeCheckboxChange} />

                    <Form.Checkbox
                      radio
                      label={Strings.MANUAL}
                      checked={!this.state.isAutomaticCheckboxChecked}
                      value={Constants.MANUAL_CHECKBOX_VAL}
                      onChange={this.handleVisualizationTypeCheckboxChange} />
                  </Form.Group>
                </Form>

                <Dropdown
                  id="devices-dropdown"
                  style={dropdownStyle}
                  placeholder="Dispositivos"
                  fluid
                  selection
                  scrolling
                  options={dropdownOptions}
                  onChange={this.onDevicesDropdownChange} />
              </Segment>

              <Segment>

                <Divider horizontal style={dividerStyle}>
                  {Strings.CONTROLS}
                  <Popup position='bottom center' hoverable pinned
                    trigger={<Icon name="info circle" color="teal" />}>
                    <Popup.Content>
                      <li><b>Obs 1:</b> {Strings.CONTROLS_POPUP_TEXT_2}</li>
                      <li><b>Obs 2:</b> {Strings.CONTROLS_POPUP_TEXT}</li>
                    </Popup.Content>
                  </Popup >
                </Divider>

                <Button.Group size="large">
                  <Button
                    id="play-btn"
                    onClick={this.handlePlayButtonClick}
                    icon="play"
                    color={this.state.playButtonColor} />

                  <Button
                    id="pause-btn"
                    onClick={this.handlePauseButtonClick}
                    icon="pause"
                    color={this.state.pauseButtonColor} />

                </Button.Group>
              </Segment>

              <Segment>
                <Divider horizontal style={dividerStyle}>{Strings.CURSORS}</Divider>

                <Grid columns="2" centered verticalAlign="middle" celled>
                  <Grid.Row>
                    <Grid.Column>
                      <Button
                        id="amplitude-btn"
                        toggle
                        active={this.state.amplitudeActive}
                        onClick={this.handleAmplitudeButtonClick}
                        color="teal"
                        fluid>
                        {Strings.AMPLITUDE}
                      </Button>
                    </Grid.Column>
                    <Grid.Column textAlign="center" stretched>
                      <span id="wave-amplitude" style={cursorValuesStyle}>{Strings.AMPLITUDE_PLACEHOLDER}</span>
                    </Grid.Column>
                  </Grid.Row>

                  <Grid.Row>
                    <Grid.Column>

                      <Button
                        id="time-interval-btn"
                        toggle
                        active={this.state.timeActive}
                        onClick={this.handleTimeButtonClick}
                        color="teal"
                        fluid>
                        &Delta;{Strings.TIME_INTERVAL}
                      </Button>

                    </Grid.Column>
                    <Grid.Column textAlign="center" stretched>
                      <span id="time-interval" style={cursorValuesStyle}>{Strings.TIME_INTERVAL_PLACEHOLDER}</span>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>

              </Segment>

              <Accordion id="message-list" styled style={accordionStyle}>
                <Accordion.Title
                  style={accordionTitleStyle}
                  active={this.state.accordionIndex === 1}
                  index={1}
                  onClick={this.handleAccordionClick}
                >
                  <Icon name="exclamation triangle" />
                  {Strings.DETECTED_PROBLEMS}
                  <Icon name="dropdown" />
                </Accordion.Title>
                <Accordion.Content active={this.state.accordionIndex === 1}>
                  <div style={accordionListItemsStyle}>
                    <ul style={{ paddingLeft: 0 }}>
                      {this.state.errorMessages.map((message) => (
                        <li key={message}>{message}</li>
                      ))}
                    </ul>
                  </div>
                </Accordion.Content>
              </Accordion>

            </Grid.Column>

            <Grid.Column width={12}>
              <Segment>

                <Chart
                  options={this.state.options}
                  series={this.state.series}
                  type="line"
                  height={UtilsInstance.adjustChartHeight()} />

                <Dimmer active={this.state.isDimmerActive}>
                  <Loader>{Strings.LOADING}</Loader>
                </Dimmer>
              </Segment>

            </Grid.Column>

          </Grid.Row>
        </Grid>

      </div>
    );
  }
}

const mapStateToProps = state => ({
  channel: state.activeMenuItem.channel
});

const formStyle = {
  marginTop: "-1vh",
  marginLeft: "auto",
  marginRight: "auto",
  marginBottom: "-2vh"
};

const dividerStyle = {
  marginTop: "-0.2vh"
};

const screenStyle = {
  margin: "4vh 2vw",
  textAlign: "center",
};

const dropdownStyle = {
  display: "none",
  marginBottom: "2vh",
  marginLeft: "auto",
  marginRight: "auto"
};

const cursorValuesStyle = {
  fontSize: "1.1em"
};

const accordionStyle = {
  color: "#9F3A38",
  backgroundColor: "#FFF6F6",
  display: "none",
  marginBottom: "2vh",
};

const accordionTitleStyle = {
  color: "#9F3A38",
};

const accordionListItemsStyle = {
  textAlign: "left",
  listStylePosition: "inside",
};

export default connect(mapStateToProps)(withRouter(Oscilloscope));
